import axios from "axios";
import {
    TURNOVER_RATE, SET_ERROR, TURNOVER_VIEWS, TURNOVER_VIEW, TURNOVER_GROUPING, TURNOVER_GROUPINGS, TERMINATION_REASONS, GROUPING_ALLOW_DELETE
} from "../../types";
import ToastMessage from '../../../components/toast'

export const turnoverRate = (payload) => {
    return async (dispatch) => {
        await axios.get('api/turnover-rate/report', { params: payload }).then(response => {
            dispatch({
                type: TURNOVER_RATE,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};

export const turnoverViews = companyId => {
    return async dispatch => {
        await axios.get(`api/turnover-rate/views/${companyId}`).then(res => {
            dispatch({
                type: TURNOVER_VIEWS,
                payload: res.data || []
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const turnoverGroupings = companyId => {
    return async dispatch => {
        await axios.get(`api/turnover-rate/groupings/${companyId}`).then(res => {
            dispatch({
                type: TURNOVER_GROUPINGS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const saveTurnoverView = payload => {
    return async dispatch => {
        await axios.post('api/turnover-rate/save-view', payload).then(res => {
            dispatch({
                type: TURNOVER_VIEW,
                payload: res.data
            });
            ToastMessage("Saved!", "success");
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const saveTurnoverGrouping = payload => {
    return async dispatch => {
        await axios.post("api/turnover-rate/save-grouping", payload).then(res => {
            dispatch({
                type: TURNOVER_GROUPING,
                payload: res.data
            });
            ToastMessage("Saved!", "success");
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const deleteSavedView = viewId => {
    return async dispatch => {
        await axios.delete(`api/turnover-rate/view/${viewId}`).then(res => {
            dispatch({
                type: TURNOVER_VIEW,
                payload: res.data
            });
            ToastMessage("Deleted!", "success");
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
            ToastMessage(e.message, "error");
        });
    };
};

export const deleteCustomGrouping = groupId => {
    return async dispatch => {
        await axios.delete(`api/turnover-rate/grouping/${groupId}`).then(res => {
            dispatch({
                type: TURNOVER_GROUPING,
                payload: res.data
            });
            ToastMessage("Deleted!", "success")
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
            ToastMessage(e.message, "error");
        });
    };
};
/* 
export const terminationReasons = companyShortName => {
    return async dispatch => {
        await axios.get(`/api/turnover-rate/termination-reasons/${companyShortName}`).then(res => {
            dispatch({
                type: TERMINATION_REASONS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}; */

export const confirmDeleteGrouping = groupId => {
    return async dispatch => {
        await axios.get(`/api/turnover-rate/grouping-allow-delete/${groupId}`).then(res => {
            dispatch({
                type: GROUPING_ALLOW_DELETE,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};


